import styled from "styled-components";
import { standardBorderRadius } from "utils/form-constants";

export const TooltipContent = styled.div`
  background-color: #333;
  color: #fff;
  max-width: 250px;
  padding: 8px;
  font-size: 12px;
  border-radius: ${standardBorderRadius};
`;
